let viewer = null;

function initializeViewer(panoramaUrl) {

  const container = document.getElementById("viewer-container");

  if (!container) return;

  if (viewer) {
    viewer.destroy();
    viewer = null;
  }

  container.innerHTML = "";

  viewer = new PhotoSphereViewer.Viewer({

    container: container,

    panorama: panoramaUrl,

    defaultYaw: 0,

    defaultPitch: 0,

    mousewheel: true,

    touchmoveTwoFingers: false,

    navbar: [
      "zoom",
      "move",
      "fullscreen"
    ]

  });

}

function openViewer() {

  const modal = document.getElementById("viewer-modal");

  if (!modal) return;

  modal.classList.add("is-open");

  document.body.style.overflow = "hidden";

  const button = document.getElementById("open-3d-viewer");

  let panorama = "";

  if (button && button.dataset.panorama) {

    panorama = button.dataset.panorama;

  } else {

    // Temporary demo panorama.
    // Later this will come from Shopify.
    panorama =
      "https://photo-sphere-viewer.js.org/assets/sphere.jpg";

  }

  initializeViewer(panorama);

}

function closeViewer() {

  const modal = document.getElementById("viewer-modal");

  if (!modal) return;

  modal.classList.remove("is-open");

  document.body.style.overflow = "";

  if (viewer) {

    viewer.destroy();

    viewer = null;

  }

}
document.addEventListener("DOMContentLoaded", function () {

  const openButton = document.getElementById("open-3d-viewer");
  const closeButton = document.getElementById("close-viewer");
  const modal = document.getElementById("viewer-modal");

  if (openButton) {
    openButton.addEventListener("click", function () {
      openViewer();
    });
  }

  if (closeButton) {
    closeButton.addEventListener("click", function () {
      closeViewer();
    });
  }

  if (modal) {
    modal.addEventListener("click", function (event) {

      if (event.target === modal) {
        closeViewer();
      }

    });
  }

  document.addEventListener("keydown", function (event) {

    if (event.key === "Escape") {
      closeViewer();
    }

  });

  window.addEventListener("resize", function () {

    if (viewer) {
      viewer.resize();
    }

  });

});